@if (!!totalResults) {
  <div class="row shadow py-3 bg-white rounded-3">
    <div class="col d-flex align-items-center justify-content-center justify-content-lg-start">
      <a
        aria-label="Назад"
        queryParamsHandling="merge"
        [routerLink]="currentRoute"
        [queryParams]="selectedPage !== firstPage ? {page: selectedPage - 1} : null"
        [class.disabled]="selectedPage === firstPage"
        [ngClass]="selectedPage !== 1 && selectedPage === lastPage ? 'btn-dark' : 'text-dark'"
        class="btn btn-outline-light border rounded-end-0 flex-grow-1 flex-sm-grow-0 px-0 px-sm-4">
        <i class="fa-solid fa-chevron-left"></i>
      </a>
      @for (page of pageOptions; track page.number; let last = $last) {
        <a class="btn  border border-start-0 rounded-0 text-dark"
           queryParamsHandling="merge"
           [routerLink]="currentRoute"
           [queryParams]="page.number > 0 ? {page: page.number} : null"
           [ngClass]="page.number == selectedPage ? 'btn-nz-primary' : 'btn-outline-light'"
           [class.disabled]="page.number <= 0"
           [class.border-end-0]="last">
          {{ page.label }}
        </a>
      }
      <a aria-label="Напред"
         queryParamsHandling="merge"
         [routerLink]="currentRoute"
         [queryParams]="selectedPage !== lastPage ? {page: selectedPage + 1} : null"
         [ngClass]="selectedPage !== lastPage ? 'btn-dark' : 'btn-outline-light text-dark disabled'"
         class="btn border rounded-start-0 flex-grow-1 flex-sm-grow-0 px-0 px-sm-4">
        <i class="fa-solid fa-chevron-right"></i>
      </a>
    </div>
    <div class="col-md-4 d-none d-lg-block">
      <ng-select
        [clearable]="false"
        [searchable]="false"
        [items]="pageLimitOptions"
        bindValue="id"
        bindLabel="name"
        [inputAttrs]="{ name: 'page-limit-option' }"
        [(ngModel)]="selectedPageLimitOptionId"
        (ngModelChange)="onPageLimitOptionChange()">
      </ng-select>
    </div>
  </div>
}
